import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { CoreToasterProvider } from '@amzn/dots-core-ui';
import { FiltersContextProvider } from '$/hooks/useProjectsFilters';
import { Home } from './Home';
import { RootUri, ProjectUri, BuildFileUri } from './routes';
import {
  ProjectDetailPage,
  ProjectListPage,
  BuildFilesListPage,
} from './Project';
// import { ProjectListPage } from './Project'

export type AppRouterProps = {
  isRootApp: boolean;
};

export const AppRouter = ({ isRootApp }: AppRouterProps): JSX.Element => {
  return (
    <CoreToasterProvider>
      <Switch>
        <Route path={`${RootUri}`}>
          <Home />
        </Route>
        <Route path={`${ProjectUri}/:id`}>
          <ProjectDetailPage />
        </Route>
        <Route path={`${ProjectUri}`}>
          <FiltersContextProvider>
            <ProjectListPage />
          </FiltersContextProvider>
        </Route>
        <Route path={`${BuildFileUri}/:name/:version`}>
          <BuildFilesListPage />
        </Route>
        {isRootApp && <Redirect to={`${ProjectUri}`} />}
      </Switch>
    </CoreToasterProvider>
  );
};
